var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rno-action-panel"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.addBar}})])
}
var staticRenderFns = []

export { render, staticRenderFns }